import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function Footer(props) {
  return (
    <footer className='footer_bg'>
      <div className='container'>
        <div className='col-lg-10 offset-lg-1'>
          <div className='clearfix'>
            <span className='float-start'>
              <div className=''>
                <h2 className='footer-social-heading'>
                  FOLLOW VIKING LEGENDS ON
                </h2>
                <div className='d-flex '>
                  <div className=''>
                    <img className='img-fluid' src='assets/images/icon1.png' />
                  </div>
                  <div className=''>
                    <img className='img-fluid' src='assets/images/icon2.png' />
                  </div>
                  <div className=''>
                    <img className='img-fluid' src='assets/images/icon3.png' />
                  </div>
                  <div className=''>
                    <img className='img-fluid' src='assets/images/icon4.png' />
                  </div>
                  <br />
                  <br />
                </div>
              </div>
            </span>
            <span className='float-end'>
              <img
                className='img-fluid footer_play'
                src='assets/images/google-play-badge.png'
              />
            </span>
          </div>
        </div>
      </div>
      <hr className='container footer_b' />
      <div className='container mt-4'>
        <div className='clearfix'>
          <span className='float-start'>
            <ul className='nav custom_fnav'>
              <li className='nav-item'>
                <a className='nav-link' href='#'>
                  Terms of Service
                </a>
              </li>
              <li className='nav-item'>
                <a className='nav-link' href='#'>
                  Privacy Policy
                </a>
              </li>
              <li className='nav-item'>
                <a className='nav-link' href='#'>
                  Safe Play
                </a>
              </li>
            </ul>
          </span>
          <span className='float-end'>
            <Link to='/'>
              {' '}
              <img className='footer_logo' src='assets/images/logo2.png' />
            </Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
export default Footer;
